import { createAction, props } from '@ngrx/store';

export const setWithIOFRelatedAction = createAction(
  '[WITH_IOF] Set WITH_IOF',
  props<{ withIOFRelated: boolean }>()
);
